export const CURRENT_TAB_ID = 'currentTabId';
export const TABS_TARGET = 'tabs';
